import {
  cyan500, cyan700,
  pinkA200,
  grey100, grey300, grey400, grey500,
  white, darkBlack, fullBlack,
} from 'material-ui/styles/colors';
import { fade } from 'material-ui/utils/colorManipulator';

export default {
  primary1Color: cyan500,
  primary2Color: cyan700,
  primary3Color: grey400,
  accent1Color: pinkA200,
  accent2Color: grey100,
  accent3Color: grey500,
  textColor: darkBlack,
  alternateTextColor: white,
  secondaryTextColor: 'rgba(0, 0, 0, 0.60)',
  canvasColor: white,
  borderColor: grey300,
  disabledColor: fade(darkBlack, 0.3),
  pickerHeaderColor: cyan500,
  clockCircleColor: fade(darkBlack, 0.07),
  shadowColor: fullBlack,
  h1: {
    fontFamily: 'Roboto',
    fontSize: 32,
    fontWeight: 300,
    marginTop: '2em',
    marginBottom: '1.5em',
    color: darkBlack,
  },
  h2: {
    fontFamily: 'Roboto',
    fontSize: 24,
    fontWeight: 300,
    marginTop: '2em',
    marginBottom: '1.5em',
    color: darkBlack,
  },
};



// WEBPACK FOOTER //
// ./src/styles/index.js